import {Box} from "@mui/system"
import {ResponsiveRow} from "../../../constants/layout.constants"
import {Typography, Tooltip} from "@mui/material"
import Location from "@mui/icons-material/LocationOn"
import Straighten from "@mui/icons-material/Straighten"
import Bed from "@mui/icons-material/AirlineSeatFlat"
import Bath from "@mui/icons-material/Bathtub"
import Favorite from "@mui/icons-material/Favorite"
import NotFavorite from "@mui/icons-material/FavoriteBorder"
import {formatCurrency, hasValidImages} from "../../../util/util"
import {GET_LISTING_IMAGE_URL} from "../../../constants/url.constants";
import placeholderImage from "../../../images/building-placeholder.png"

export default function ExploreListing(props) {
    const fullListingName = `${props.listing.propertyName} (${props?.listing?.propertyType?.name || ''})`

    return (
        <ResponsiveRow
            onClick={() => {
                props.listingSelected(props.listing)
            }}
            sx={{
                width: {xs: "100%", lg: "320px"},
                height: "450px",
                borderRadius: "20px",
                alignItems: "flex-start",
                backgroundColor: "#fff",
                padding: 0,
                margin: "10px",
                "&:hover": {
                    transform: "scale(1.1)",
                    transitionDuration: "ease-in-out 700ms",
                },
            }}
        >
            <Box
                component="img"
                alt={hasValidImages(props.listing) ? "Property image" : "No image available"}
                src={
                    hasValidImages(props.listing)
                        ? GET_LISTING_IMAGE_URL + "?filename=" + props.listing.imageFiles[0].systemFileName
                        : placeholderImage
                }
                sx={{
                    width: "100%",
                    height: "50%",
                    objectFit: "cover",
                    borderRadius: "20px 20px 0 0",
                    opacity: hasValidImages(props.listing) ? 1 : 0.8,  // Subtle indication of placeholder
                }}
            />
            <ResponsiveRow
                sx={{
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    justifyContent: "flex-start",
                    width: "100%",
                    height: "50%",
                    textAlign: "start",
                    padding: "10px 20px",
                }}
            >
                <ResponsiveRow
                    sx={{
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 0,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{color: "#afafaf", fontWeight: 600, marginBottom: "5px"}}
                    >
                        Ksh {formatCurrency(props.listing.price)}
                    </Typography>
                    <ResponsiveRow
                        sx={{
                            flexWrap: "nowrap",
                            width: "50%",
                            justifyContent: "flex-end",
                            alignItems: "center",
                        }}
                    >
                        {props.listing.favorite ? (
                            <Favorite sx={{margin: "auto 5px", color: "red", zIndex: 3}}/>
                        ) : (
                            <NotFavorite
                                sx={{margin: "auto 5px", color: "#aeaeae", zIndex: 3}}
                            />
                        )}
                        <Typography
                            variant="body2"
                            sx={{
                                color: "#fff",
                                backgroundColor: "#00B9AE",
                                padding: "5px 10px",
                                fontWeight: 600,
                                marginBottom: "5px",
                                marginLeft: 0,
                                borderRadius: "10px",
                            }}
                        >
                            {props.listing.listingType.name}
                        </Typography>
                    </ResponsiveRow>
                </ResponsiveRow>

                <ResponsiveRow>
                    <Tooltip title={fullListingName} arrow>
                        <Typography 
                            variant="h5" 
                            sx={{
                                fontWeight: 700, 
                                marginBottom: "10px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                wordBreak: "break-word"
                            }}
                        >
                            {fullListingName}
                        </Typography>
                    </Tooltip>
                </ResponsiveRow>
                <Typography
                    variant="body2"
                    sx={{marginBottom: "5px", color: "#00B9AE"}}
                >
                    <Location sx={{fontSize: "1.2rem"}}/> {props.listing.plusCode}
                </Typography>
                <Typography sx={{fontSize: "1rem", marginBottom: "10px"}}>
                    <Straighten sx={{fontSize: "1.2rem"}}/> {formatCurrency(props.listing.sqft)} SqM
                </Typography>
                <ResponsiveRow
                    sx={{
                        flexWrap: "nowrap",
                        width: "80%",
                        padding: 0,
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{margin: "0 10px 0 0", fontSize: "1rem"}}
                    >
                        <Bed sx={{fontSize: "1.2rem"}}/> {props.listing.beds}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{margin: "0 10px 0 0", fontSize: "1rem"}}
                    >
                        <Bath sx={{fontSize: "1.2rem"}}/> {props.listing.baths}
                    </Typography>
                </ResponsiveRow>
            </ResponsiveRow>
        </ResponsiveRow>
    )
}
